import { Fragment, memo } from 'react';

import { useRelativeTimeFromNow } from '../../hooks/useRelativeTimeFromNow';

export type FormattedRelativeTimeFromNowProps = {
  /** Reference date to compare to now. */
  date: string;
  /** Max number of seconds between the date and now before rendering absolute date. */
  limitRelative?: number;
  /** Dayjs format when rendering absolute date. */
  absoluteFormat?: string;
};

export const FormattedRelativeTimeFromNowBase = ({
  date,
  // Default to a week.
  limitRelative = 7 * 24 * 60 * 60,
  absoluteFormat = 'LL',
}: FormattedRelativeTimeFromNowProps) => {
  const { formattedDate } = useRelativeTimeFromNow(date, {
    limitRelative,
    absoluteFormat,
  });

  return (
    // Need to use JSX to make docgen and eslint detect this as a component.

    <Fragment>{formattedDate}</Fragment>
  );
};

FormattedRelativeTimeFromNowBase.displayName = 'FormattedRelativeTimeFromNow';

export const FormattedRelativeTimeFromNow = memo(FormattedRelativeTimeFromNowBase);
